<div #agmmaparea id="agmmaparea" class="map-wrapper">
	<div class="fixed-map">
		<agm-map #map *ngIf="center" id="stgmap" [hidden]="!ui.mapstate" [latitude]="center.lat"
			[longitude]="center.lng" [zoom]="zoom" (mapReady)="mapready($event)" (mapClick)="mapclick($event)"
			(idle)="updatemap($event)" scrollwheel></agm-map>
		<div *ngIf="ui.mapstate" id="map-tools" class="amg-map-tools">
			<button class="zoomin-button" matTooltip="Zoom In" matTooltipPosition="left" mat-mini-fab (click)="zoomin()"
				color="accent" [disabled]="atminzoom()">
				<mat-icon color="$primary" aria-label="Zoom in">zoom_in</mat-icon>
			</button>
			<button class="zoomout-button" matTooltip="Zoom Out" matTooltipPosition="left" mat-mini-fab
				(click)="zoomout()" color="accent" [disabled]="atmaxzoom()">
				<mat-icon color="$primary" aria-label="Zoom out">zoom_out</mat-icon>
			</button>
			<span class="layout-spacer"></span>
			<button class="locator-button" matTooltip="Find Me" matTooltipPosition="left" mat-mini-fab
				(click)="centeruser()" color="accent" *ngIf="s.settings.center_user.value == '1'">
				<mat-icon color="$primary" aria-label="Find Me">my_location</mat-icon>
			</button>
			<button mat-mini-fab (click)="updatemap()" color="accent">
				<mat-icon matTooltip="Loading" matTooltipPosition="left" [hidden]="!active" aria-label="Loading Data"
					class="spin-refresh">refresh</mat-icon>
				<mat-icon matTooltip="Refresh Map" matTooltipPosition="left" [hidden]="active"
					aria-label="Done">refresh</mat-icon>
			</button>
		</div>
		<button id="togglemapbutton" mat-button class="map-toggle" (click)="toggle_map()">
			{{ui.maptoggletext}}
			<mat-icon class="layout-icon" color="white">{{ui.maptoggleicon}}</mat-icon>
		</button>
	</div>
</div>

<div [hidden]="showfilter" id="properties" #resultsarea>

	<div class="properties-search-results">

		<div class="prop-sort">
			<div class="prop-sort-item prop-sort-dropdown">
				<span>Sort By:</span>
				<mat-form-field appearance="none">
					<mat-select [ngModel]="s.settings.sort.value" (ngModelChange)="setting_change($event,'sort')">
						<mat-option *ngFor="let value of s.keys(s.settings.sort.options)" [value]="value">
							{{s.settings.sort.options[value]}}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>


		<ng-container *ngIf="fs.sort_order">
			<div *ngIf="loading">
				<mat-progress-spinner mode="indeterminate" color="primary"
					class="loading-spinner"></mat-progress-spinner>
			</div>

			<ng-container *ngIf="fs.sort_order.length>0 && map.total_shown_communities > 0">
				<mat-card *ngFor="let id of fs.sort_order let i = index" (click)="cardClick($event, id)"
					class="property-item prop-{{image_orientation(fs.all_communities[id])}}"
					[class.selected]="map.selected_community && id == map.selected_community.id"
					[class.member]="ismember(fs.all_communities[id])"
					[class.featured]="community_type(id) == 'featured'"
					[ngClass]="{ 'property-partner' : fs.all_communities[id].tier > 1 || community_type(id) == 'featured' , 'property-free' : fs.all_communities[id].tier == 0 || fs.all_communities[id].tier == 1 }"
					[ngSwitch]="community_type(id)" [attr.id]="'community-'+id" #elem>

					<ng-container *ngSwitchCase="'featured'">

						<!--inner start-->
						<mat-card-header>
							<div class="crd-hdr-block crd-hdr-info">
								<mat-card-subtitle class="crd-sort">
									<span class="crd-sort-rank">
										<mat-icon matTooltip="Highlight On Map" matTooltipPosition="right"
											(click)="selectcommunity(fs.all_communities[id],$event)"
											aria-label="Show On Map">place</mat-icon>
										<span class="crd-sort-id">{{fs.all_communities[id].sort_index}}</span>
									</span>
									<ng-container *ngIf="fs.filters_count()">
										<span class="crd-sort-match">{{format_match(id)}}</span>
										<!--might need following line, leaving cancelled 4 now-->
										<!-- <mat-progress-bar color="warn" mode="determinate" value="{{fs.all_communities[id].score}}"></mat-progress-bar> -->
									</ng-container>
								</mat-card-subtitle>

								<mat-card-title class="crd-title"
									(mouseenter)="selectcommunity(fs.all_communities[id],$event)">
									{{fs.all_communities[id].name}}
								</mat-card-title>

								<mat-card-subtitle class="crd-loc" *ngIf="fs.all_communities[id].address">
									<span class="crd-loc-city">{{fs.all_communities[id].address.city}},
										{{fs.all_communities[id].address.state}}</span>
									<span class="separator">&middot;</span>
									<span class="crd-loc-dist">{{map.community_distance(id,1)}} Miles</span>
								</mat-card-subtitle>
							</div>
							<div class="crd-hdr-block crd-hdr-contact">
								<mat-card-subtitle class="crd-budget">
									{{format_budget(fs.all_communities[id].budget_range)}}
								</mat-card-subtitle>

								<a mat-stroked-button
									*ngIf="fs.all_communities[id].tier == 0 || fs.all_communities[id].tier == 1"
									class="btn-icon" (click)="cardClick($event, id)" aria-label="Call Community">
									<span class="icon-wrap">
										<mat-icon class="mat-icon-phone">phone</mat-icon>
									</span>
									<span>Contact</span>
								</a>

								<a mat-stroked-button *ngIf="fs.all_communities[id].tier > 1"
									class="btn-icon btn-icon-contact"
									(click)="selectcommunity(fs.all_communities[id],$event)"
									aria-label="Community Details">
									<span class="icon-wrap">
										<mat-icon class="mat-icon-email">email</mat-icon>
										<mat-icon class="mat-icon-phone">phone</mat-icon>
									</span>
									<span>Contact</span>
								</a>

								<div style="display: none;">
									{{fs.all_communities[id] | json}}
								</div>

							</div>
						</mat-card-header>

						<div class="img-wrapper" *ngIf="fs.all_communities[id].tier > 1"
							(click)="showcommunity(fs.all_communities[id])">
							<span *ngIf="fs.all_communities[id].banner" class="bg-img"
								style="display: none; background: url({{fs.all_communities[id].banner.lo_res}});"><!--intentionally left blank--></span>
							<div *ngIf="!fs.all_communities[id].banner" class="svg-wrap svg-icon-butterfly">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 582.12 599.29">
									<g data-name="Layer 2">
										<path
											d="M419.71 456a157.52 157.52 0 0030.46-20c32.73-27.28 59-68.61 74.08-116.46 31.52-100.84 2.15-200.17-65.53-221.33-15.17-4.73-31-5.16-47.08-1.85a284.34 284.34 0 00-38.5-48.91C333.63 7.83 290-7.72 249.94 3.61S180 51.24 165.53 105.9c-10.86 41.26-11.94 89.68-3.48 139.33-34.61 6.21-66.33 17.06-92.63 31.84C24.11 302.46-.46 336.69 0 373.43c.57 48.2 44.15 88.89 110.13 111h.07c-8.19 20.73-8.42 39.74.17 55.36 10.45 19.06 32.14 30.13 62.08 32a166.72 166.72 0 0021.55-.19c37.31-2.6 80.9-16.6 122.58-39.47 30.7-16.8 57.81-37 78.89-58.56A103.66 103.66 0 00419.71 456zm6.23-334.23a65.68 65.68 0 019.8-.24 63.62 63.62 0 0114.77 2.73c53.31 16.69 74.63 100.57 47.58 187-9.07 28.91-22.66 54.94-39.33 76.27.46-1.41.84-2.85 1.25-4.24s.77-2.89 1.15-4.34a289.29 289.29 0 009-62.26c.44-10.93.31-22.13-.35-33.51q-.66-11.28-2-22.88c-1.38-11.54-3.27-23.2-5.65-34.86-.07 0 0-.06 0-.06q-2.42-11.73-5.54-23.41c-.69-2.61-1.42-5.21-2.1-7.83-3.62-12.48-7.72-24.67-12.28-36.46-1.54-3.87-3.13-7.71-4.75-11.49-1.09-2.41-2.11-4.8-3.17-7.16-2.68-5.91-5.47-11.65-8.4-17.29l-3.39-6.6c1.16 2.24 2.27 4.41 3.41 6.63zm-233-11.39c11.8-44.69 34.37-73.81 63.61-82.07A62.36 62.36 0 01275.67 26c24.43.58 50.76 14.18 76.08 39.63 11.62 11.57 22.3 25.2 32.25 40.28 4.84 7.52 9.59 15.26 14 23.54a372.5 372.5 0 0131.2 80.29c9.68 36.36 14 72.58 12.79 106.35a264.7 264.7 0 01-6.34 50.21c-.65 2.72-1.16 5.52-1.81 8.25-6.32 24-15.9 43.33-27.79 57.45-8.74 10.51-18.85 18-30 22.38a45.59 45.59 0 01-5.84 2.18c-10.24 2.88-20.91 3-32.07.73a96.87 96.87 0 01-19.93-6.75c-14.35-6.62-28.94-17-43.17-31.2a238.11 238.11 0 01-25.16-29.91c-5.3-7.3-10.13-15.13-14.88-23.22-15.8-26.83-28.61-57.69-37.45-91.13-.62-2.28-1.14-4.6-1.66-6.92-2.26-9-4.13-18-5.66-26.94-8.23-46.87-7.49-92.44 2.7-130.84zM27.37 373c-.3-26.26 19.34-51.86 55.46-72.05 23.9-13.46 52.91-23.24 84.7-29 .85 3.63 1.66 7.28 2.6 10.81a386.41 386.41 0 0040.15 97.45c4.71 8 9.56 15.69 14.7 23.05a259.12 259.12 0 0028.62 34.17 184 184 0 0040.56 31.23A366.88 366.88 0 01151.54 467c-9.78-2.1-19.06-4.61-28.11-7.5-56.74-17.95-95.59-50.07-96.06-86.5zm276.06 135.12c-7.81 4.27-15.67 8.12-23.52 11.7a318.33 318.33 0 01-37 14.28 227.61 227.61 0 01-48.15 9.9c-.9.07-1.84.22-2.73.29-16 1.11-29.41-.38-39.59-4-8.48-3.06-14.75-7.61-18.07-13.67-3.48-6.32-3.88-14.49-1.5-23.87.06-.23.09-.44.15-.66s.14-.42.19-.62a74.54 74.54 0 013.35-9.43c6.51 1.59 13.21 2.92 20 4.13 1 .19 2 .45 3 .63s2.41.32 3.59.51q6.31 1 12.79 1.82c1.72.22 3.42.46 5.15.66 6.19.69 12.47 1.27 18.86 1.7h.5c1 .07 2 .08 3.05.13 6.6.36 13.32.53 20.12.59 2.76 0 5.51.09 8.3.07 2.43 0 4.79-.08 7.21-.15 1.25 0 2.44-.16 3.67-.22q6.57-.3 13-.76c1.79-.13 3.62-.17 5.39-.31 8.92-.75 17.7-1.73 26.27-3 4.46-.68 8.78-1.42 13.14-2.24 3.52-.65 6.95-1.44 10.39-2.19 1.13-.25 2.29-.46 3.41-.72 5.93-1.35 11.76-2.81 17.43-4.43 2-.52 3.88-1.08 5.81-1.7h.13c-7.78 5.54-16.08 10.77-24.61 15.84-3.16 1.87-6.36 3.86-9.73 5.72zm-103.06-51.59C159.18 454 83.05 441.17 54.68 383.19a11.74 11.74 0 1121.09-10.31c32.07 65.55 149.46 60.69 150.64 60.64a11.73 11.73 0 011.15 23.48 263.06 263.06 0 01-27.19-.47zm16.27-210.21a11.73 11.73 0 1122.51-6.63c34.41 117 87.38 162.61 108.56 176.79 8.94 6 6.31 13.49 5.29 15.65a11.88 11.88 0 01-11.45 6.68 11.35 11.35 0 01-2.69-.48 11.75 11.75 0 01-4.53-2.55c-23.5-15.84-81.33-65.67-117.69-189.46zM582 481.26a17.14 17.14 0 01-19.13 14.91c-81.33-10.09-152.22 25.72-185 93.43A17.15 17.15 0 01347 574.66c39.4-81.38 123.74-124.51 220.11-112.53A17.14 17.14 0 01582 481.26z"
											fill="#231f20" data-name="Layer 1" />
									</g>
								</svg>
							</div>
							<img mat-card-image *ngIf="fs.all_communities[id].banner"
								src="{{fs.all_communities[id].banner.lo_res}}">
							<span mat-raised-button class="btn-icon-cta">
								<span class="btn-mat-icon" matTooltip="View Profile">
									<mat-icon>info</mat-icon>
								</span>
								<span class="btn-txt">View Profile</span>
							</span>
						</div>
						<!--inner end-->

					</ng-container>

					<ng-container *ngSwitchCase="'member'">

						<!--inner start-->
						<mat-card-header>
							<div class="crd-hdr-block crd-hdr-info">
								<mat-card-subtitle class="crd-sort">
									<span class="crd-sort-rank">
										<mat-icon matTooltip="Highlight On Map" matTooltipPosition="right"
											(click)="selectcommunity(fs.all_communities[id],$event)"
											aria-label="Show On Map">place</mat-icon>
										<span class="crd-sort-id">{{fs.all_communities[id].sort_index}}</span>
									</span>
									<ng-container *ngIf="fs.filters_count()">
										<span class="crd-sort-match">{{format_match(id)}}</span>
										<!--might need following line, leaving cancelled 4 now-->
										<!-- <mat-progress-bar color="warn" mode="determinate" value="{{fs.all_communities[id].score}}"></mat-progress-bar> -->
									</ng-container>
								</mat-card-subtitle>

								<mat-card-title class="crd-title"
									(mouseenter)="selectcommunity(fs.all_communities[id],$event)">
									{{fs.all_communities[id].name}}
								</mat-card-title>

								<mat-card-subtitle class="crd-loc" *ngIf="fs.all_communities[id].address">
									<span class="crd-loc-city">{{fs.all_communities[id].address.city}},
										{{fs.all_communities[id].address.state}}</span>
									<span class="separator">&middot;</span>
									<span class="crd-loc-dist">{{map.community_distance(id,1)}} Miles</span>
								</mat-card-subtitle>
							</div>
							<div class="crd-hdr-block crd-hdr-contact">
								<mat-card-subtitle class="crd-budget">
									{{format_budget(fs.all_communities[id].budget_range)}}
								</mat-card-subtitle>

								<a mat-stroked-button
									*ngIf="fs.all_communities[id].tier == 0 || fs.all_communities[id].tier == 1"
									class="btn-icon" (click)="cardClick($event, id)" aria-label="Call Community">
									<span class="icon-wrap">
										<mat-icon class="mat-icon-phone">phone</mat-icon>
									</span>
									<span>Contact</span>
								</a>

								<a mat-stroked-button *ngIf="fs.all_communities[id].tier > 1"
									class="btn-icon btn-icon-contact"
									(click)="selectcommunity(fs.all_communities[id],$event)"
									aria-label="Community Details">
									<span class="icon-wrap">
										<mat-icon class="mat-icon-email">email</mat-icon>
										<mat-icon class="mat-icon-phone">phone</mat-icon>
									</span>
									<span>Contact</span>
								</a>

								<div style="display: none;">
									{{fs.all_communities[id] | json}}
								</div>

							</div>
						</mat-card-header>

						<div class="img-wrapper" *ngIf="fs.all_communities[id].tier > 1"
							(click)="showcommunity(fs.all_communities[id])">
							<span *ngIf="fs.all_communities[id].banner" class="bg-img"
								style="display: none; background: url({{fs.all_communities[id].banner.lo_res}});"><!--intentionally left blank--></span>
							<div *ngIf="!fs.all_communities[id].banner" class="svg-wrap svg-icon-butterfly">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 582.12 599.29">
									<g data-name="Layer 2">
										<path
											d="M419.71 456a157.52 157.52 0 0030.46-20c32.73-27.28 59-68.61 74.08-116.46 31.52-100.84 2.15-200.17-65.53-221.33-15.17-4.73-31-5.16-47.08-1.85a284.34 284.34 0 00-38.5-48.91C333.63 7.83 290-7.72 249.94 3.61S180 51.24 165.53 105.9c-10.86 41.26-11.94 89.68-3.48 139.33-34.61 6.21-66.33 17.06-92.63 31.84C24.11 302.46-.46 336.69 0 373.43c.57 48.2 44.15 88.89 110.13 111h.07c-8.19 20.73-8.42 39.74.17 55.36 10.45 19.06 32.14 30.13 62.08 32a166.72 166.72 0 0021.55-.19c37.31-2.6 80.9-16.6 122.58-39.47 30.7-16.8 57.81-37 78.89-58.56A103.66 103.66 0 00419.71 456zm6.23-334.23a65.68 65.68 0 019.8-.24 63.62 63.62 0 0114.77 2.73c53.31 16.69 74.63 100.57 47.58 187-9.07 28.91-22.66 54.94-39.33 76.27.46-1.41.84-2.85 1.25-4.24s.77-2.89 1.15-4.34a289.29 289.29 0 009-62.26c.44-10.93.31-22.13-.35-33.51q-.66-11.28-2-22.88c-1.38-11.54-3.27-23.2-5.65-34.86-.07 0 0-.06 0-.06q-2.42-11.73-5.54-23.41c-.69-2.61-1.42-5.21-2.1-7.83-3.62-12.48-7.72-24.67-12.28-36.46-1.54-3.87-3.13-7.71-4.75-11.49-1.09-2.41-2.11-4.8-3.17-7.16-2.68-5.91-5.47-11.65-8.4-17.29l-3.39-6.6c1.16 2.24 2.27 4.41 3.41 6.63zm-233-11.39c11.8-44.69 34.37-73.81 63.61-82.07A62.36 62.36 0 01275.67 26c24.43.58 50.76 14.18 76.08 39.63 11.62 11.57 22.3 25.2 32.25 40.28 4.84 7.52 9.59 15.26 14 23.54a372.5 372.5 0 0131.2 80.29c9.68 36.36 14 72.58 12.79 106.35a264.7 264.7 0 01-6.34 50.21c-.65 2.72-1.16 5.52-1.81 8.25-6.32 24-15.9 43.33-27.79 57.45-8.74 10.51-18.85 18-30 22.38a45.59 45.59 0 01-5.84 2.18c-10.24 2.88-20.91 3-32.07.73a96.87 96.87 0 01-19.93-6.75c-14.35-6.62-28.94-17-43.17-31.2a238.11 238.11 0 01-25.16-29.91c-5.3-7.3-10.13-15.13-14.88-23.22-15.8-26.83-28.61-57.69-37.45-91.13-.62-2.28-1.14-4.6-1.66-6.92-2.26-9-4.13-18-5.66-26.94-8.23-46.87-7.49-92.44 2.7-130.84zM27.37 373c-.3-26.26 19.34-51.86 55.46-72.05 23.9-13.46 52.91-23.24 84.7-29 .85 3.63 1.66 7.28 2.6 10.81a386.41 386.41 0 0040.15 97.45c4.71 8 9.56 15.69 14.7 23.05a259.12 259.12 0 0028.62 34.17 184 184 0 0040.56 31.23A366.88 366.88 0 01151.54 467c-9.78-2.1-19.06-4.61-28.11-7.5-56.74-17.95-95.59-50.07-96.06-86.5zm276.06 135.12c-7.81 4.27-15.67 8.12-23.52 11.7a318.33 318.33 0 01-37 14.28 227.61 227.61 0 01-48.15 9.9c-.9.07-1.84.22-2.73.29-16 1.11-29.41-.38-39.59-4-8.48-3.06-14.75-7.61-18.07-13.67-3.48-6.32-3.88-14.49-1.5-23.87.06-.23.09-.44.15-.66s.14-.42.19-.62a74.54 74.54 0 013.35-9.43c6.51 1.59 13.21 2.92 20 4.13 1 .19 2 .45 3 .63s2.41.32 3.59.51q6.31 1 12.79 1.82c1.72.22 3.42.46 5.15.66 6.19.69 12.47 1.27 18.86 1.7h.5c1 .07 2 .08 3.05.13 6.6.36 13.32.53 20.12.59 2.76 0 5.51.09 8.3.07 2.43 0 4.79-.08 7.21-.15 1.25 0 2.44-.16 3.67-.22q6.57-.3 13-.76c1.79-.13 3.62-.17 5.39-.31 8.92-.75 17.7-1.73 26.27-3 4.46-.68 8.78-1.42 13.14-2.24 3.52-.65 6.95-1.44 10.39-2.19 1.13-.25 2.29-.46 3.41-.72 5.93-1.35 11.76-2.81 17.43-4.43 2-.52 3.88-1.08 5.81-1.7h.13c-7.78 5.54-16.08 10.77-24.61 15.84-3.16 1.87-6.36 3.86-9.73 5.72zm-103.06-51.59C159.18 454 83.05 441.17 54.68 383.19a11.74 11.74 0 1121.09-10.31c32.07 65.55 149.46 60.69 150.64 60.64a11.73 11.73 0 011.15 23.48 263.06 263.06 0 01-27.19-.47zm16.27-210.21a11.73 11.73 0 1122.51-6.63c34.41 117 87.38 162.61 108.56 176.79 8.94 6 6.31 13.49 5.29 15.65a11.88 11.88 0 01-11.45 6.68 11.35 11.35 0 01-2.69-.48 11.75 11.75 0 01-4.53-2.55c-23.5-15.84-81.33-65.67-117.69-189.46zM582 481.26a17.14 17.14 0 01-19.13 14.91c-81.33-10.09-152.22 25.72-185 93.43A17.15 17.15 0 01347 574.66c39.4-81.38 123.74-124.51 220.11-112.53A17.14 17.14 0 01582 481.26z"
											fill="#231f20" data-name="Layer 1" />
									</g>
								</svg>
							</div>
							<img mat-card-image *ngIf="fs.all_communities[id].banner"
								src="{{fs.all_communities[id].banner.lo_res}}">
							<span mat-raised-button class="btn-icon-cta">
								<span class="btn-mat-icon" matTooltip="View Profile">
									<mat-icon>info</mat-icon>
								</span>
								<span class="btn-txt">View Profile</span>
							</span>
						</div>
						<!--inner end-->

					</ng-container>

					<ng-container *ngSwitchDefault class="not-member">

						<ng-container *ngIf="fs.all_communities[id]">

							<!--inner start-->
							<mat-card-header>
								<div class="crd-hdr-block crd-hdr-info">
									<mat-card-subtitle class="crd-sort">
										<span class="crd-sort-rank">
											<mat-icon matTooltip="Highlight On Map" matTooltipPosition="right"
												(click)="selectcommunity(fs.all_communities[id],$event)"
												aria-label="Show On Map">place</mat-icon>
											<span class="crd-sort-id">{{fs.all_communities[id].sort_index}}</span>
										</span>
										<ng-container *ngIf="fs.filters_count()">
											<span class="crd-sort-match">{{format_match(id)}}</span>
										</ng-container>
									</mat-card-subtitle>

								</div>
								<div class="crd-hdr-block crd-hdr-contact">
									<mat-card-subtitle class="crd-budget">
										{{format_budget(fs.all_communities[id].budget_range)}}
									</mat-card-subtitle>

									<div style="display: none;">
										{{fs.all_communities[id] | json}}
									</div>

								</div>
							</mat-card-header>

							<div class="crd-main">
								<div class="crd-main-inner">

									<div class="img-wrapper crd-main-avatar thumb-{{thumb_orientation(fs.all_communities[id])}}"
										(click)="showcommunity(fs.all_communities[id])">
										<ng-template [ngIf]="fs.all_communities[id].thumbnail?.length > 0"
											[ngIfElse]="avatarTxt">
											<span class="crd-avatar-inner crd-avatar-img bg-img">
												<div *ngFor='let item of fs.all_communities[id].thumbnail | slice:0:1'>
													<span class="bg-blur" style="background: url({{item.lo_res}});">
														<!--intentionally left blank-->
													</span>
													<img src="{{item.lo_res}}" alt="Community building">
												</div>
											</span>
										</ng-template>
										<ng-template #avatarTxt>
											<div class="crd-avatar-inner crd-avatar-txt">
												<span class="crd-avatar-initials">
													{{com_initials(id) | slice:0:1}}
												</span>
											</div>
										</ng-template>
									</div>

									<mat-card-title-group class="crd-main-txt">
										<mat-card-title class="crd-title"
											(mouseenter)="selectcommunity(fs.all_communities[id],$event)">
											{{fs.all_communities[id].name}}
										</mat-card-title>

										<mat-card-subtitle class="crd-loc" *ngIf="fs.all_communities[id].address">
											<span class="crd-loc-city">{{fs.all_communities[id].address.city}},
												{{fs.all_communities[id].address.state}}</span>
											<span class="separator">&middot;</span>
											<span class="crd-loc-dist">{{map.community_distance(id,1)}} Miles</span>
										</mat-card-subtitle>
									</mat-card-title-group>

									<div class="crd-main-contact"
										*ngIf="fs.all_communities[id].tier == 0 || fs.all_communities[id].tier == 1">
										<button mat-mini-fab color="accent" (click)="cardClick($event, id)"
											aria-label="Call Community">
											<!--<mat-icon class="mat-icon-phone">phone</mat-icon>-->
											<span class="mat-icon-alt-wrapper">
												<span
													class="mat-icon-alt mat-icon-phone"><!--intentionally left blank--></span>
											</span>
										</button>

										<!--<a mat-mini-fab *ngIf="fs.all_communities[id].tier == 0 || fs.all_communities[id].tier == 1" (click)="cardClick($event, id)" aria-label="Call Community">
															<span class="icon-wrap">
																<mat-icon class="mat-icon-phone">phone</mat-icon>	
															</span>										
														</a>-->
									</div>

								</div>
							</div>

							<!--inner end-->

						</ng-container>

					</ng-container>

				</mat-card>
			</ng-container>


			<!-- <mat-card *ngIf="fs.sort_order.length==0 || map.total_shown_communities == 0" class="no-matches">
				<mat-card-header>
					<mat-card-title>
						No Matches for this Area
					</mat-card-title>
					<mat-card-subtitle>
						Zoom out or pan the map
					</mat-card-subtitle>
				</mat-card-header>
			</mat-card> -->

			<mat-card *ngIf="fs.sort_order.length==0" class="no-matches">
				<mat-card-header>
					<mat-card-title>
						<span *ngIf="map.total_shown_communities != 0">Loading...</span>
						<span *ngIf="map.total_shown_communities == 0">No Matches for this Area</span>
					</mat-card-title>
					<mat-card-subtitle *ngIf="map.total_shown_communities == 0">Zoom out or pan the
						map</mat-card-subtitle>
				</mat-card-header>
			</mat-card>




		</ng-container>
	</div>
	<ng-container *ngIf="!fs.all_communities">
		<mat-progress-spinner mode="indeterminate" color="primary" class="loading-spinner"></mat-progress-spinner>
	</ng-container>
</div>